// extracted by mini-css-extract-plugin
module.exports = {"styles":"_1egRg87H_s31Y59JePSryH"};